"use client";

import Script from "next/script";

export default function GoogleTagHeaderManager() {
    return (
        <>
            {/*<Script*/}
            {/*    id="google-tag"*/}
            {/*    src="https://www.googletagmanager.com/gtag/js?id=GTM-MB6CSV32"*/}
            {/*    strategy="afterInteractive"*/}
            {/*/>*/}

            <Script
                id="google-tag-manager"
                strategy="afterInteractive"
                dangerouslySetInnerHTML={{
                    __html: `
                        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-MB6CSV32');
                    `,
                }}
            />
        </>
    );
}